import Attribute from "vueforms/src/xmlrdb-metadata/Attribute"

Attribute.ValidatorFunctionRegistry["BIC"] = (attr) => {
  const swift = attr.value;
  if (!swift || swift.length < 8){
    return "SWIFT ist zu kurz";
  }
  let bicUeberpruefung = swift.substring(0,6);
  if (bicUeberpruefung.search(/^[a-zA-Z]+$/) == -1){
    return "SWIFT enthält ungültige Zeichen";
  }
  bicUeberpruefung = swift.substring(6);
  if (bicUeberpruefung.trim().search(/^[a-zA-Z0-9]+$/) == -1){
    return "SWIFT enthält ungültige Zeichen";
  }
}

Attribute.ValidatorFunctionRegistry["IBAN"] = (attr) => {
  const iban = attr.value;
  if (!iban || iban.length < 22)
    return "IBAN zu kurz";
  let ibanUeberpruefung = iban.substring(0,2);
  if (ibanUeberpruefung.search(/^[a-zA-Z]+$/) == -1)
    return "IBAN enthält ungültige Zeichen";
  ibanUeberpruefung = iban.substring(2);
  if (ibanUeberpruefung.search(/^[0-9]+$/) == -1)
    return "IBAN enthält ungültige Zeichen";
}